import { Component, Input } from "@angular/core";
import { FunnelSettingsProvider } from "src/app/providers/funnel-settings";
import { UrlsProvider } from "src/app/providers/urls";

@Component({
  selector: "footer-common",
  styleUrls: ['./footer-common.scss'],
  templateUrl: "./footer-common.html"
})
export class FooterCommonComponent {
  currentYear: number = new Date().getFullYear();
  @Input() brand: string = '';
  @Input() address: string = '123 main st';
  @Input() mainText: string = '';
  @Input() mainTextMobile: string = '';
  @Input() links: Array<string> = [];
  @Input() swapFormat: boolean = false;
  @Input() footerDisclaimer: boolean = false;
  @Input() footerDisclaimerText: string;
  @Input() copyrightText: string = `© ${ this.brand } ${ this.currentYear }. All Rights Reserved.`;
  @Input() footerEmail: string = "support@drmartypets.com"
  readonly copyrightSymbol: string = "© ";
  readonly allRightsReserved: string = ". All Rights Reserved ";
  brandLogo: string = 'https://cdn.drmartypets.com/images/logo_white.png';
  window: any = window;
  phoneNumber: string = "1-800-670-1839";
  footerText: string= "";

  constructor(public funnelProvider: FunnelSettingsProvider, public urls: UrlsProvider) {}

}
